import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { ConnectHoliduWizardComponent } from './connect-holidu-wizard.component'
import { ConnectHoliduWizardCompleteComponent } from './complete/connect-holidu-wizard-complete.component'
import { ConnectHoliduWizardStep1Component } from './step1/connect-holidu-wizard-step1.component'
import { ConnectHoliduWizardStep2Component } from './step2/connect-holidu-wizard-step2.component'

import { SharedModule } from '@tv3/shared/shared.module'

const components = [
  // Holidu
  ConnectHoliduWizardStep1Component,
  ConnectHoliduWizardStep2Component,
  ConnectHoliduWizardCompleteComponent,
  ConnectHoliduWizardComponent,
]

const services = [
  //
]

const pipes = []

@NgModule({
  declarations: [...components, ...pipes],
  exports: [...components],
  providers: [...services],
  imports: [CommonModule, SharedModule, Tv3PlatformModule],
})
export class ConnectHoliduWizardModule {}
